import { cv } from "@suse-o11y/class-variance";
import { type ReadonlySignal, useComputed } from "@suse-o11y/signal";
import React from "react";

import type { TableOverflowState } from "./_overflow-state";
import styles from "./_table.module.css";

const variants = cv(styles.tableScrollIndicator, {
	variants: {
		direction: {
			left: styles.left,
			right: styles.right,
		},

		active: {
			true: styles.active,
		},
	},
});

export interface TableScrollIndicatorProps {
	overflowState: ReadonlySignal<undefined | TableOverflowState>;
}

export const TableScrollIndicator: React.FC<TableScrollIndicatorProps> = ({ overflowState }) => {
	const overflow = useComputed(overflowState);

	if (overflow == null) {
		return null;
	}

	return (
		<div className="pointer-events-none absolute inset-0 z-5 flex">
			<div className={variants({ direction: "left", active: overflow.left, className: null })} />
			<div className="flex-1" />
			<div className={variants({ direction: "right", active: overflow.right, className: null })} />
		</div>
	);
};
